import styled from 'styled-components';

type FilledProps = {
  $percentage: number;
};

export const Empty = styled.div`
  background-color: ${({ theme }) => theme.color.ui5};
  border: 0.5px;
  border-radius: 4px;
  border-style: solid;
  border-color: ${({ theme }) => theme.color.ui4};
  height: 8px;
`;

export const Filled = styled.div<FilledProps>`
  height: 100%;
  background-color: ${(props) => props.theme.color.s1};
  border-radius: 4px;
  height: 8px;
  transition: all 300ms;
  width: ${(props) => props.$percentage}%;
`;
